export enum TrafficAccessRulesKeyEnum {
  // --- Модуль TRAFFIC (Трафик) ---
  // --- Раздел TRAFFIC.SECTIONS.TRAFFIC (Трафик) ---

  // Вкладка "Оборудование"
  TRAFFIC_TRAFFIC_ADAPTER_READ = 'TRAFFIC_TRAFFIC_ADAPTER_READ',
  TRAFFIC_TRAFFIC_ADAPTER_WRITE = 'TRAFFIC_TRAFFIC_ADAPTER_WRITE',

  // Вкладка "Трафик"
  TRAFFIC_TRAFFIC_REPORT_READ = 'TRAFFIC_TRAFFIC_REPORT_READ'
}
